import { MagazinePistolIcon } from './MagazinePistolIcon';

/**
 * author: Andrew Laws
 * id DC51467E-30C0-4144-9AE6-80762ACA972C
 * name magazine-pistol
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magazine-pistol.svg
 * tags
 */
export const AmmunitionPistolIcon = MagazinePistolIcon;
export default AmmunitionPistolIcon